// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1va9V","title":"Header_title__3CTIx","side":"Header_side__3bt2E"};